import { render, staticRenderFns } from "./Layout-2.vue?vue&type=template&id=bf7d0b60&"
import script from "./Layout-2.vue?vue&type=script&lang=js&"
export * from "./Layout-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports